import { render } from "./ClientNotaCredito.vue?vue&type=template&id=7e64cf6b"
import script from "./ClientNotaCredito.vue?vue&type=script&lang=js"
export * from "./ClientNotaCredito.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__